export enum ResultsOfClimbingStairs {    
    Unknown = -1,
    NoProblem = 0,
    ShortnessOfBreath = 1,
    ChestPain = 2,
    UnableToClimb = 3
}